<template>
  <div class="layout-header">
    <div class="header-wrap">
      <div class="logo">
        <img src="@/assets/images/logo2.png" alt="" />
        <!-- <img src="@/assets/images/headerlogo.png" alt="" />
        <el-divider direction="vertical"></el-divider>
        <p>用户账户中心</p> -->
      </div>
      <div class="nav">
        <ul>
          <el-button type="primary" @click="goNext(1)" icon="icon shouye0"
            >官网首页</el-button
          >
          <el-button type="primary" @click="goNext(2)" icon="icon quzheng0"
            >电子取证</el-button
          >
          <el-button type="primary" @click="goNext(5)" icon="icon shouji0"
            >权利卫士APP</el-button
          >
          <el-button type="primary" @click="goNext(3)" icon="icon zhishi0"
            >知识产权</el-button
          >
          <el-button type="primary" @click="goNext(6)" icon="icon email0"
            >邮件认证</el-button
          >
          <!-- <el-button type="primary" @click="goNext(4)" icon="icon qianming0"
            >电子签名</el-button
          > -->
          <!-- <el-button type="primary" @click="goNext(7)" icon="icon yizhu0"
            >遗嘱卫士</el-button
          > -->
          <!-- <el-button type="primary" @click="goNext(5)" icon="icon fuwu0"
            >时间戳公共服务</el-button
          > -->
            <p class="lawyer" @click="goLawyer">
                <img src="../../icons/ico/lawyer-icon.png" alt="">
                <b>找律师</b>
            </p>

        </ul>
      </div>
      <div class="userinfo">
        <!--        <span class="quit"><i class="el-icon-switch-button"></i> &nbsp;&nbsp;返回官网</span>-->
        <el-dropdown class="system-user" @command="userCommand">
          <span class="account">
            <i class="el-icon-user"></i> &nbsp;&nbsp;{{ userinfo.loginName }}</span
          >
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="editpwd">修改密码</el-dropdown-item>
            <el-dropdown-item divided command="logout"
              >退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      activeIndex: "1",
    };
  },

  components: {},

  computed: {
    userinfo:{
        get() {
            return this.$store.state.userInfo.userinfo;
        },
        set(val) {
            this.$store.state.userInfo.userinfo = val;
        },        
    },
    channelCodeValue(){
        return this.$store.state.config.channelCodeValue;
    },
  },
  created() {
  },
  mounted() {},

  methods: {
    goLawyer(){
        let sourceType=this.$getlocalStorage("queryData")?.sourceType || this.$getlocalStorage("queryData")?.clientId || 975260;
        window.open(`${process.env.VUE_APP_LAWCASE}/user/index?location=user_navi&sourceType=`+sourceType);
    },
    goNext(n) {
      switch (n) {
        case 1:
            zhuge.track('用户中心_导航进官网首页', {'渠道': this.channelCodeValue})
          window.open(process.env.VUE_APP_TSA);
          break;
        case 2:
            zhuge.track('用户中心_导航进电子证据', {'渠道': this.channelCodeValue})
          window.open(process.env.VUE_APP_EV+'/vm_fetch');
          break;
        case 3:
            zhuge.track('用户中心_导航进知产保护', {'渠道': this.channelCodeValue})
          window.open(process.env.VUE_APP_COPYRIGHT+'/time/ApplyTime');
          break;
        // case 4:
        //     zhuge.track('用户中心_导航进电子签名', {'渠道': this.channelCodeValue})
        //   window.open(process.env.VUE_APP_SIGN);
        //   break;
        case 5:
            zhuge.track('用户中心_导航进权利卫士', {'渠道': this.channelCodeValue})
          window.open(process.env.VUE_APP_TSA+'/quanliweishi.html');
          break;
        case 6:
            zhuge.track('用户中心_导航进邮件认证', {'渠道': this.channelCodeValue})
          window.open(process.env.VUE_APP_EMAIL+'/emailProof/witnessEmail');
          break;
        case 7:
          window.open(process.env.VUE_APP_WILL);
          break;
      }
      // window.open(data)
    },
    userCommand(command) {
      var that = this;
      if (command == "editpwd") {
        zhuge.track('用户中心_导航修改密码', {'渠道': this.channelCodeValue},()=> {
            this.$router.push({path:"/userCenter/security"}) //继续跳转到目标页面
        })
      }
      if (command == "logout") {
        that.$store.commit("userInfo/setuserinfo", null);
        localStorage.removeItem("queryData");
        zhuge.track('用户中心_导航退出登录', {'渠道': this.channelCodeValue},()=> {
            window.location.href = "/api/logout";
        })
      }
    },
  },
};
</script>
<style scoped lang="less">
.header-wrap {
  display: flex;
  flex-direction: row;
  height: 60px;
  // border: 1px solid #e3e3e5;
  background: #fff;
  border-top: none; 
  box-shadow: 0px 7px 8px 0px rgba(0, 0, 0, 0.06);

  .logo {
    margin-left: 134px;
    display: flex;
    flex-direction: row;
    line-height: 80px;
    justify-content: flex-end;
    padding-right: 30px;
    align-items: center;
    z-index: 999;

    img {
      height: 40px;
      float: left;
    }

    p {
      width: 100px;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      float: left;
    }
  }
}

.nav {
  font-size: 16px;
  flex: 8;
    .lawyer{
        cursor: pointer;
        font-size: 14px;
        margin:0 18px;
        display: flex;
        align-items: center;
        padding: 7px 12px;
        background: #fff;
        border-radius: 18px;
        line-height: 0;
        box-shadow: 0px 4px 4px 0px rgba(0,71,255,0.1);
        height: 35px;
        box-sizing: border-box;
        border:1px solid #0047FF;
        img{
            width: 14px;
            height: 14px;
            display: block;
            margin-right: 5px;
        }
        b{
            color: #0047FF;
            padding: 0;
            display: block;
        }
        // &:hover{
        //     color: #1F5EFF;
        //     i,span{
        //         color: #1F5EFF;
        //     }
        // }
    }
}

.nav ul {
  display: flex;
  flex-direction: row;
  line-height: 80px;
  justify-content: flex-end;
  padding-right: 30px;
  align-items: center;
}

.nav ul {
  padding-right: 30px;

  /deep/ .el-button {
    border-radius: 0;
    height: 60px;
    margin-left: 0;
    background-color: #fff;
    border-color: #fff;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    padding:8px 18px;
    display: flex;
    flex-direction: row;
    align-items: center;
    &:hover {
      // background-color: #409eff;
      // border-color: #409eff;
      color: #409eff;
    }

    // &:nth-child(1):hover {
    //   .shouye0 {
    //     background: url("../../icons/svg/1shouye.png") center no-repeat;
    //     background-size: 20px;
    //   }
    // }

    // &:nth-child(2):hover {
    //   .quzheng0 {
    //     background: url("../../icons/svg/1quzheng.png") center no-repeat;
    //     background-size: 22px;
    //   }
    // }

    // &:nth-child(3):hover {
    //   .zhishi0 {
    //     background: url("../../icons/svg/1zhishi.png") center no-repeat;
    //     background-size: 17px;
    //   }
    // }

    // &:nth-child(4):hover {
    //   .qianming0 {
    //     background: url("../../icons/svg/1qianming.png") center no-repeat;
    //     background-size: 19px;
    //   }
    // }

    // &:nth-child(5):hover {
    //   .shouji0 {
    //     background: url("../../icons/svg/1shouji.png") center no-repeat;
    //     background-size: 12px;
    //   }
    // }
    span{
      font-size: 16px;
    }
  }

  /deep/ .shouye0 {
    background: url("../../icons/ico/shouye.png") center no-repeat;
  }

  /deep/ .quzheng0 {
    background: url("../../icons/ico/quzheng.png") center no-repeat;
  }

  /deep/ .zhishi0 {
    background: url("../../icons/ico/zhishi.png") center no-repeat;
  }

  /deep/ .email0 {
    background: url("../../icons/ico/emailIco.png") center no-repeat;
  }

  /deep/ .qianming0 {
    background: url("../../icons/ico/qianming.png") center no-repeat;
  }

  /deep/ .shouji0 {
    background: url("../../icons/ico/shouji.png") center no-repeat;
  }

  /deep/ .fuwu0 {
    background: url("../../icons/ico/fuwu.png") center no-repeat;
  }

  /deep/ .yizhu0 {
    background: url("../../icons/ico/yizhu.png") center no-repeat;
    background-size: 20px;
  }

  /deep/ .icon {
    margin-right: 10px;
    font-size: 24px;
  }

  /deep/ .icon:before {
    content: "替";
    font-size: 20px;
    visibility: hidden;
  }


  // /deep/ .shouji0:before {
  //   font-size: 12px;
  // }

  // /deep/ .quzheng0:before {
  //   font-size: 24px;
  // }
}

.nav ul li a {
  color: #333;
}

.nav ul li a:hover {
  color: #6288fb;
}

.userinfo {
  font-size: 14px;
  line-height: 60px;
  flex: 2;

  .system-user {
    vertical-align: middle;
  }

  .quit {
    vertical-align: middle;
  }
}

.userinfo span {
  vertical-align: middle;
  display: inline-block;
  padding: 0 15px;
  cursor: pointer;
}

.userinfo span:hover {
  color: #6288fb;
}

.my-el-menu .el-menu-item {
  color: #333;
}

.account {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;
  white-space: nowrap;
}

.ico {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  margin-right: 4px !important;
}

@media screen and (max-width: 1460px) {
  .nav {
    flex: 6;
  }

  .nav ul {
    padding-right: 15px;

    .el-button {
      padding: 8px 12px;
    }
  }
}
@media screen and (max-width: 1390px) {
  .nav ul {
    /deep/.el-button {
      .icon{
        display: none !important;
      }
    }
  }
}
</style>

